import React, { useState } from "react";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import ContratoAutocomplete from "../../../components/autocomplete/ContratoAutocomplete";
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroProductoContrato({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // Estados de los objetos seleccionados
  const [contratoObj, setContratoObj] = useState(initialFilters.contratoObj || null);
  const [productoObj, setProductoObj] = useState(initialFilters.productoObj || null);
  
  // Campos numéricos
  const [qnProducto, setQnProducto] = useState(initialFilters.qnProducto || "");
  const [valorMontoDescuento, setValorMontoDescuento] = useState(initialFilters.valorMontoDescuento || "");
  
  const [isLoading, setIsLoading] = useState(false);

  const handleApply = () => {
    setIsLoading(true);

   // Función para limpiar números: eliminar puntos y comas
  const cleanNumber = (val) => {
    if (!val) return "";
    return val.toString().replace(/[.,]/g, "");
  };

    onSubmit({
  contratoObj: contratoObj,
  productoObj: productoObj,
  qnProducto: cleanNumber(qnProducto),
  valorMontoDescuento: cleanNumber(valorMontoDescuento),
});

    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Productos en Contrato"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* Contrato */}
      <div>
        <label className="form-label-fil">Contrato:</label>
        <div className="mt-1 w-full">
          <ContratoAutocomplete
            value={contratoObj}
            onChange={(obj) => setContratoObj(obj)}
            placeholder="Buscar por código..."
          />
        </div>
      </div>

      {/* Producto */}
      <div>
        <label className="form-label-fil">Producto:</label>
        <div className="mt-1 w-full">
          <ProductoAutocomplete
            value={productoObj}
            onChange={(obj) => setProductoObj(obj)}
            placeholder="Buscar por código o nombre..."
          />
        </div>
      </div>

      {/* Separador */}
      <div className="border-t border-gray-200 my-2"></div>

      {/* Cantidad de Producto */}
      <div>
        <label className="form-label-fil">Cantidad de Producto:</label>
        <InputNumberNoScroll 
          className="input mt-1 w-full" 
          value={qnProducto} 
          onChange={(e) => setQnProducto(e.target.value)} 
          placeholder="Ej: 100"
        />
      </div>

      {/* Valor de Descuento Producto */}
      <div>
        <label className="form-label-fil">Valor de Descuento Producto:</label>
        <InputNumberNoScroll 
          className="input mt-1 w-full" 
          value={valorMontoDescuento} 
          onChange={(e) => setValorMontoDescuento(e.target.value)} 
          placeholder="Ej: 5000"
        />
      </div>
    </DrawerFilter>
  );
}